import { provide as provider } from '../../mixins/registrable'

export default {
  name: 'list',

  mixins: [ provider('list') ],

  data () {
    return {
      groups: []
    }
  },

  props: {
    dense: Boolean,
    light: Boolean,
  },

  computed: {
    classes () {
      return {
        'list': true,
        'list--dense': this.dense,
        'list--light': this.light,
      }
    }
  },

  methods: {

    // registrable-provider-register
    register(group) {
      this.groups.push(group)
      group.$on('list-group-activated', this.onGroupOpened)
    },


    // registrable-provider-unregister
    unregister(group) {
      group.$off('list-group-activated', this.onGroupOpened)
      let index = this.groups.indexOf(group)
      if(index >= 0) this.groups.splice(index, 1)
    },

    onGroupOpened(group) {
      this.groups.forEach(registeredGroup => {
        if(registeredGroup != group) // close other groups
          registeredGroup.isActive = false
      })
    }
  },

  render (h) {
    const data = {
      'class': this.classes,
    }

    return h('ul', data, [this.$slots.default])
  }
}